export default {
  Title      : 'Past Analyses',
  HeaderTitle: 'Past Analyses',
  Tab        : {
    PastAnalyses: {
      Title: 'Past Analyses',
      Slug : 'past-analyses'
    }
  }
}
